import React from 'react'
import { ScreeningQuestion } from 'types/campaign'

interface ScreeningQuestionMCQProps {
    question: ScreeningQuestion
    index: number
    value: string | number
    onChange: (value: string) => void
    highlightError?: boolean
}

const ScreeningQuestionMCQ: React.FC<ScreeningQuestionMCQProps> = ({
    question,
    index,
    value,
    onChange,
    highlightError = false,
}) => (
    <div className="screening-question">
        <p className="screening-question__title">
            {index + 1}. {question.question}
        </p>
        <div className="screening-question__options">
            {(question.options ?? []).map((option) => {
                const selected = String(value) === option
                return (
                    <button
                        key={option}
                        type="button"
                        className={`screening-question__option${selected ? ' screening-question__option--selected' : ''}`}
                        onClick={() => onChange(option)}
                    >
                        <span
                            className={`screening-question__radio${
                                selected ? ' screening-question__radio--selected' : ''
                            }`}
                            aria-hidden
                        />
                        <span className="screening-question__option-label">{option}</span>
                    </button>
                )
            })}
        </div>
        {highlightError && (
            <div className="text-danger fs-14 mt-1">Please select a valid option</div>
        )}
    </div>
)

export default ScreeningQuestionMCQ
